import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { BuyitemPage } from './buyitem';

@NgModule({
  declarations: [
    BuyitemPage,
  ],
  imports: [
    IonicPageModule.forChild(BuyitemPage),
  ],
})
export class BuyitemPageModule {}



// WEBPACK FOOTER //
// ./src/pages/buyitem/buyitem.module.ts